import React, { useState } from 'react';
import { Analytics } from '@vercel/analytics/react';
import { Toaster } from './components/ui/sonner';
import ExtractionForm from './components/ExtractionForm';
import ExtractionProgress from './components/ExtractionProgress';
import DataDisplay from './components/DataDisplay';
import { Database, Sparkles } from 'lucide-react';

export default function App() {
  const [extractionState, setExtractionState] = useState('idle'); // idle, processing, completed
  const [extractionData, setExtractionData] = useState(null);
  const [progressData, setProgressData] = useState({
    currentFile: '',
    filesProcessed: 0,
    totalFiles: 0,
    startTime: null,
    elapsedTime: 0,
    progress: 0,
    formData: null
  });

  const handleStartExtraction = (formData) => {
    setExtractionState('processing');
    
    setProgressData({
      currentFile: '',
      filesProcessed: 0,
      totalFiles: formData.fileCount || 1,
      startTime: Date.now(),
      elapsedTime: 0,
      progress: 0,
      formData: formData.formData || null
    });
    
    // Store form data for backend integration
    console.log('Starting extraction with:', formData);
  };

  const handleExtractionComplete = (data) => {
    setExtractionState('completed');
    setExtractionData(data);
  };

  const handleReset = () => {
    setExtractionState('idle');
    setExtractionData(null);
    setProgressData({
      currentFile: '',
      filesProcessed: 0,
      totalFiles: 0,
      startTime: null,
      elapsedTime: 0,
      progress: 0,
      formData: null
    });
  };

  return (
    <div className="min-h-screen bg-gradient-subtle">
      {/* Header */}
      <header className="border-b border-border bg-card shadow-sm">
        <div className="container mx-auto px-4 py-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="flex h-12 w-12 items-center justify-center rounded-xl gradient-primary shadow-accent">
                <Database className="h-6 w-6 text-primary-foreground" />
              </div>
              <div>
                <h1 className="text-2xl font-bold text-foreground tracking-tight">DataExtract Pro</h1>
                <p className="text-sm text-muted-foreground">Intelligent data extraction made simple</p>
              </div>
            </div>
            <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-accent/10 border border-accent/20">
              <Sparkles className="h-4 w-4 text-accent" />
              <span className="text-sm font-medium text-accent">AI-Powered</span>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="container mx-auto px-4 py-8">
        <div className="max-w-6xl mx-auto space-y-6">
          {extractionState === 'idle' && (
            <ExtractionForm onStartExtraction={handleStartExtraction} />
          )}
          
          {extractionState === 'processing' && (
            <ExtractionProgress 
              progressData={progressData}
              setProgressData={setProgressData}
              onComplete={handleExtractionComplete}
            />
          )}
          
          {extractionState === 'completed' && extractionData && (
            <DataDisplay 
              data={extractionData} 
              onReset={handleReset}
            />
          )}
        </div>
      </main>

      <Toaster position="top-right" />
      <Analytics />
    </div>
  );
}
